import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

const GA4_ID = 'G-NV36YF53GX';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);

  constructor() {
    if (!isPlatformBrowser(this.platformId)) return;

    // El snippet de GA4 ya está en index.html.
    // NavigationEnd se dispara también para la ruta inicial, por lo que no
    // es necesario un _trackPageView manual — evita el doble tracking.
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this._trackPageView(e.urlAfterRedirects);
      });
  }

  private _trackPageView(url: string): void {
    if (typeof window?.gtag !== 'function') return;
    window.gtag('config', GA4_ID, { page_path: url });
  }

  trackEvent(eventName: string, params: Record<string, unknown> = {}): void {
    if (!isPlatformBrowser(this.platformId) || typeof window?.gtag !== 'function') return;
    window.gtag('event', eventName, params);
  }
}
